/* global axios */
const url = accountId => `/api/v1/accounts/${accountId}/activation_guide`;

export default {
  get: accountId => axios.get(url(accountId)),
  send: (accountId, payload) =>
    axios.post(`${url(accountId)}/messages`, payload),
  start: (accountId, channel) =>
    axios.post(`${url(accountId)}/attempts`, { channel }),
  updateAttempt: (accountId, attemptId, status) =>
    axios.patch(`${url(accountId)}/attempts/${attemptId}`, { status }),
  connect: (accountId, attemptId, credentials) =>
    axios.post(`${url(accountId)}/attempts/${attemptId}/connect`, credentials),
  authorization: (accountId, provider, attemptId) =>
    axios.post(`/api/v1/accounts/${accountId}/${provider}/authorization`, {
      return_to: 'activation_guide',
      attempt_id: attemptId,
    }),
  event: (accountId, guideAction) =>
    axios.post(`${url(accountId)}/events`, { guide_action: guideAction }),
};
